import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function Date() {

    DataTable.use(DT);

    const navigate = useNavigate();

    const columns = [
        { data: 'progressivo', type: 'string' },
        { data: 'dataISO', type: 'string' },
        { data: 'dataTestuale' },
        {
            width: '87px',
            data: 'id',
            orderable: false
        }
    ];

    const options = {
        language: getDataTablesLanguage(),
    };

    const [tableData, setTableData] = useState([]);  

    function handleDetailsClick(data) {
        navigate(`/date/${data}`);
    }

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/date`)
            .then(function (response) {
                setTableData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <div className="row">
                    <div className="col">
                        <h4>Date</h4>
                    </div>
                    <div className="col text-end">
                        <a href="/date/new" style={{ position: 'relative', top: 7 }} onClick={(ev) => { ev.preventDefault(); navigate("/date/new") }}>Crea nuova data</a>
                    </div>
                </div>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>
                <DataTable data={tableData} columns={columns} options={options} className="table"
                    slots={{
                        3: (data, row) => (
                            <a href={`date/${data}`} onClick={(ev) => { ev.preventDefault(); handleDetailsClick(data) }}>Dettagli</a>
                        )
                    }}
                >
                    <thead>
                        <tr>
                            <th>Progressivo</th>
                            <th>Data ISO</th>
                            <th>Data testuale</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>

        </>
    )
}
